import Vue from 'vue'
import { Input, Tooltip } from 'ant-design-vue'
import { savePreviousData, instance, errorService } from '@/services/api'
import { masterAPIs, projectAPIs } from '@/services/authConstantsV1'
import { showNotification } from '@/services/calculate'

Vue.use(Input)
Vue.use(Tooltip)

export default Vue.extend({
  template: `
    <div class="a-gcell" v-if="value!=='none' && !params.data.applicationId">
      <a-spin :spinning="loading">
        <a-icon slot="indicator" type="loading" :class="params.type === 'masterData' || params.type === 'Template' || params.type === 'Project' ? 'status-loader' : 'loader-spin'"/>
        <a-tooltip placement="right" :title="value ? true : false" v-if="params.type === 'analysisSheet'">
          <a-switch size="small"  @focus="savePreviousData(params.data.avoidVariance)" :disabled="params.data.isLinked || params.isArchive" :checked="value" @change="saveData($event)"/>
        </a-tooltip>
        <a-tooltip placement="right" :title="value ? 'true' : 'false'" v-if="params.type === 'templateAnalysisSheet'">
          <a-switch size="small":disabled="params.viewOnly" :checked="value" @change="saveData($event)"/>
        </a-tooltip>
        <a-tooltip placement="right" :title="value ? 'Active' : 'Inactive'" v-if="params.type === 'masterData' || params.type === 'Project' || params.type === 'Template'">
          <a-switch size="small" :disabled="params.data.isLinked" :checked="value" @change="saveData($event)"/>
        </a-tooltip>
        <a-tooltip placement="right" :title="value ? 'Unlink' : 'Link'" v-if="params.colDef.cellRendererParams.assetType === 'Link' && !params.data.costBasis && params.data.costBasis != 'Total'">
          <a-switch size="small" :disabled="!this.isLinked" :checked="value" @change="updateLinking($event)"/>
        </a-tooltip>
      </a-spin>
    </div>
    `,

  data() {
    return {
      value: null,
      loading: false,
      savePreviousData: savePreviousData,
      statusMessage: null,
      updateReq: null,
      apiURL: null,
      isLinked: undefined,
    }
  },
  created() {
    if (this.params.type === 'projectDetails' && this.params.value !== 'none') {
      this.isLinked = this.params.colDef.cellRendererParams.isLinked
      this.value = !!this.params.value
    } else if (this.params.type === 'templateAnalysisSheet') {
      this.value = this.params.value
    } else {
      this.value = !!this.params.value
    }
  },
  methods: {
    updateLinking(value) {
      if (this.params.value && this.params.data.analysisTypeId === 1) {
        const that = this
        this.$confirm({
          title: `Are you sure want to unlink asset?`,
          content: h => (
            <div style="color:red;">
              <p>
                This action will delete all data related to this asset:
                {'  '}
                {this.params.data.description || this.params.data.assetNumber}.
              </p>
              <p>Please confirm</p>
            </div>
          ),
          onOk() {
            that.saveData(value)
          },
          onCancel() {},
        })
      } else {
        this.saveData(value)
      }
    },

    saveData(value) {
      if (this.params.type === 'projectDetails') {
        this.value = value
      } else if (this.params.type === 'templateAnalysisSheet') {
        this.value = value
      } else {
        this.value = value
      }
      switch (this.params.type) {
        case 'analysisSheet':
          this.$root.$emit(
            'saveAnalysisData',
            this.value ? 1 : 0,
            this.params.data,
            this.params.colDef.field,
            this.params.data.columnId,
            this.params.dataType,
          )
          break
        case 'templateAnalysisSheet':
          this.$root.$emit(
            'saveAnalysisData',
            this.value,
            this.params.data,
            this.params.colDef.field,
            this.params.data.columnId,
            this.params.dataType,
          )
          break
        case 'projectDetails':
          this.$root.$emit('linkUnlinkAsset', this.value, this.params.data.id)
          break
        case 'masterData':
        case 'Template':
        case 'Project':
          this.value = this.params.data.isActive
          this.changeStatus(this.params.data, value ? 1 : 0)
          break
      }
    },

    getValue() {
      return this.value
    },

    // Confirm Popup
    changeStatus(data, value) {
      let method = 'put'
      switch (this.params.masterType) {
        case 'projectDetails':
          break
        case 'ASSET_CLASS':
          this.statusMessage = `${data.asset_Class} - ${data.description}`
          this.updateReq = this.params.data
          switch (this.params.type) {
            case 'Template':
              break
            case 'Project':
              method = 'patch'
              this.apiURL = projectAPIs.master.assetClass.details(
                this.$route.params.id,
                this.params.data.id,
              )
              this.statusMessage = `${data.assetClass} - ${data.description}`
              this.updateReq = { isActive: value }
              break
            default:
              method = 'patch'
              this.apiURL = masterAPIs.assetClass.details(this.params.data.id)
              this.statusMessage = `${data.assetClass} - ${data.description}`
              this.updateReq = { isActive: value }
              break
          }
          break
        case 'BSUOP':
          this.statusMessage = `${data.bsuoP_Description}`
          this.updateReq = this.params.data
          switch (this.params.type) {
            case 'Template':
              break
            case 'Project':
              method = 'patch'
              this.apiURL = projectAPIs.master.bsuop.details(
                this.$route.params.id,
                this.params.data.id,
              )
              this.statusMessage = `${data.description}`
              this.updateReq = { isActive: value }
              break
            default:
              method = 'patch'
              this.apiURL = masterAPIs.bsuop.details(this.params.data.id)
              this.statusMessage = `${data.description}`
              this.updateReq = { isActive: value }
              break
          }
          break
        case 'CATEGORY_CODE':
          this.statusMessage = `${data.category_Code} - ${data.description}`
          this.updateReq = this.params.data
          switch (this.params.type) {
            case 'Template':
              break
            case 'Project':
              method = 'patch'
              this.apiURL = projectAPIs.master.categoryCode.details(
                this.$route.params.id,
                this.params.data.id,
              )
              this.statusMessage = `${data.categoryCode} - ${data.description}`
              this.updateReq = { isActive: value }
              break
            default:
              method = 'patch'
              this.apiURL = masterAPIs.categoryCode.details(
                this.params.data.id,
              )
              this.statusMessage = `${data.categoryCode} - ${data.description}`
              this.updateReq = { isActive: value }
              break
          }
          break
        case 'CONTRACT':
          this.statusMessage = `${data.contract} - ${data.contract_Name}`
          this.updateReq = this.params.data
          switch (this.params.type) {
            case 'Template':
              break
            case 'Project':
              method = 'patch'
              this.apiURL = projectAPIs.master.contract.details(
                this.$route.params.id,
                this.params.data.id,
              )
              this.statusMessage = `${data.contract} - ${data.contractName}`
              this.updateReq = { isActive: value }
              break
            default:
              method = 'patch'
              this.apiURL = masterAPIs.contract.details(this.params.data.id)
              this.statusMessage = `${data.contract} - ${data.contractName}`
              this.updateReq = { isActive: value }
              break
          }
          break
        case 'STRUCTURE_PROFILE':
          method = 'patch'
          this.statusMessage = data.structureProfile
          this.updateReq = {
            isActive: value,
          }
          this.apiURL = masterAPIs.structureProfile.details(
            this.params.data.id,
          )
          break
        case 'TAKEOFF':
          this.statusMessage = `${data.description}`
          switch (this.params.type) {
            case 'Template':
              Object.assign(this.params.data, {
                Master_Takeoff_Grouping_Ids: '',
                takeoff_Grouping_Ids: this.params.data.takeoffGrouping
                  .map(j => {
                    return j.takeoff_Grouping_Id
                  })
                  .join(),
              })
              break
            case 'Project':
              method = 'patch'
              this.statusMessage = `${data.description}`
              this.updateReq = {
                isActive: value,
              }
              this.apiURL = projectAPIs.master.takeoff.details(
                this.$route.params.id,
                this.params.data.id,
              )
              break
            default:
              method = 'patch'
              this.statusMessage = `${data.takeoff}`
              this.updateReq = {
                isActive: value,
              }
              this.apiURL = masterAPIs.takeoff.details(this.params.data.id)
              break
          }
          this.updateReq = this.params.data
          break
        case 'TAKEOFF_GROUPING':
          this.statusMessage = data.takeoffGrouping
          this.updateReq = this.params.data
          switch (this.params.type) {
            case 'Template':
              break
            case 'Project':
              method = 'patch'
              this.updateReq = {
                isActive: value,
              }
              this.apiURL = projectAPIs.master.takeoffGrouping.details(
                this.$route.params.id,
                this.params.data.id,
              )
              break
            default:
              method = 'patch'
              this.updateReq = {
                isActive: value,
              }
              this.apiURL = masterAPIs.takeoffGrouping.details(
                this.params.data.id,
              )
              break
          }
          break
        case 'TENANT_BANK':
          this.statusMessage = data.tenantName
          method = 'patch'
          this.updateReq = {
            isActive: data.isActive,
          }
          this.apiURL = masterAPIs.tenantBank.details(data.id)
          break
        case 'UNIT':
          this.updateReq = this.params.data
          switch (this.params.type) {
            case 'Template':
              this.statusMessage = data.unit
              break
            case 'Project':
              method = 'patch'
              this.statusMessage = data.unit
              this.apiURL = projectAPIs.master.unit.details(
                this.$route.params.id,
                this.params.data.id,
              )
              this.updateReq = { isActive: value }
              break
            default:
              method = 'patch'
              this.statusMessage = data.unit
              this.apiURL = masterAPIs.unit.details(this.params.data.id)
              break
          }
          break
        case 'ANALYSIS_TYPE':
          method = 'patch'
          this.statusMessage = data.analysisType
          this.updateReq = { isActive: value === 1 }
          this.apiURL = masterAPIs.analysisType.details(this.params.data.id)
          break
        case 'BUILDING_USE':
          method = 'patch'
          this.statusMessage = this.params.data.buildingUse
          this.updateReq = { isActive: value }
          this.apiURL = masterAPIs.buildingUse.details(this.params.data.id)
          break
        case 'CONSTRUCTION_QUALITY_FACTOR':
          method = 'patch'
          this.statusMessage = this.params.data.constructionQualityFactor
          this.updateReq = { isActive: value }
          this.apiURL = masterAPIs.constructionFactor.details(
            this.params.data.id,
          )
          break
        case 'CONDITION_FACTOR':
          method = 'patch'
          this.statusMessage = this.params.data.conditionFactor
          this.updateReq = { isActive: value }
          this.apiURL = masterAPIs.conditionFactor.details(this.params.data.id)
          break
        case 'INTERIOR_GROUPING_BANK':
          method = 'patch'
          this.statusMessage = this.params.data.label
          this.updateReq = { isActive: value }
          this.apiURL = masterAPIs.groupingBank.details(this.params.data.id)
          break
        default:
          this.statusMessage = data.option
          this.updateReq = this.params.data
          this.apiURL = masterAPIs.updateMaster(this.params.masterType)
          break
      }
      const that = this
      this.$confirm({
        title: `Are you sure you want to ${
          data.isActive === 1 || data.isActive ? 'deactivate' : 'activate'
        } '${this.statusMessage}' ?`,
        onOk() {
          that.updateMasterStatus(value, method)
        },
        onCancel() {},
        class: 'test',
      })
    },

    updateMasterStatus(value, method) {
      this.loading = true
      this.updateReq.isActive = value
      instance[method](this.apiURL, this.updateReq)
        .then(response => {
          this.value = value
          this.params.data.isActive = value
          showNotification(
            'success',
            `${this.params.data.isActive === 1 ? 'Activate' : 'Deactivate'}`,
            `${this.statusMessage} ${
              this.params.data.isActive === 1 ? 'activate' : 'deactivate'
            } successfully!`,
          )
          this.loading = false
          if (this.params.masterType === 'TAKEOFF_GROUPING') {
            this.$root.$emit('loadTakeoffGroupings', true)
          }
        })
        .catch(error => {
          errorService(error)
          this.loading = false
        })
    },
  },
})
